import Splide from "@splidejs/splide";

/**
 * Initializes the Products Slider component.
 */
const Sliders = () => {
	const sliders = document.querySelectorAll(".products-slider__wrapper-slider");
    const productThumbs = document.getElementById('product-thumbs');
    const productMainImage = document.getElementById('product-main');
    const mediaSlider = document.querySelector('.js-media-slider');

    if(mediaSlider) {
        const splideMediaSlider = new Splide('.js-media-slider', {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: false
        });

        splideMediaSlider.mount();

        const prevButtonMediaSlider = document.querySelector(".js-media-prev");
        const nextButtonMediaSlider = document.querySelector(".js-media-next");

        if (nextButtonMediaSlider) {
            nextButtonMediaSlider.addEventListener("click", () => {
                splideMediaSlider.go("+1");
            });
        }

        if (prevButtonMediaSlider) {
            prevButtonMediaSlider.addEventListener("click", () => {
                splideMediaSlider.go("-1");
            });
        }
    }

	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const splideInstance = new Splide(slider, {
				type: "loop",
				perPage: 4,
				gap: "70px",
				pagination: false,
				arrows: false,
				breakpoints: {
					1024: { 
                        perPage: 3,
                        gap: "50px"
                    },
					768: { 
                        perPage: 2,
                        gap: "30px"
                    },
					480: { 
                        perPage: 1 
                    },
				},
			});

			splideInstance.mount();

			const parent = slider.closest(".products-slider__wrapper");
			const prevButton = parent?.querySelector(".products-slider__wrapper-slider-arrows-prev");
			const nextButton = parent?.querySelector(".products-slider__wrapper-slider-arrows-next");

			if (nextButton) {
				nextButton.addEventListener("click", () => {
					splideInstance.go("+1");
				});
			}

			if (prevButton) {
				prevButton.addEventListener("click", () => {
					splideInstance.go("-1");
				});
			}
		});
	}

    if (productMainImage && productThumbs) {
        const main = new Splide('#product-main', {
            type: 'fade',
            pagination: false,
            arrows: false,
        });

        const thumbs = new Splide('#product-thumbs', {
            gap: 30,
            pagination: false,
            arrows: false,
            isNavigation: true,
            direction: 'ttb',
            height: 'auto',
            breakpoints: {
                768: {
                    direction: 'ltr',
                    perPage: 3,
                    gap: 15,
                },
            },
        });

        main.sync(thumbs);
        thumbs.mount();
        main.mount();

        // Obsługa własnych strzałek
        const prevArrow = document.querySelector('.product-gallery__arrow--prev');
        const nextArrow = document.querySelector('.product-gallery__arrow--next');

        if (prevArrow && nextArrow) {
            prevArrow.addEventListener('click', () => main.go("-1"));
            nextArrow.addEventListener('click', () => main.go("+1"));
        }
    }

};

export default Sliders;
